<div class="part-matrix">
  <!-- Main Heading -->
  <div *ngIf="!isOpenAsDialog" class="tertiary-content-header flex-between-center">
    <h4>
      <span class="font-600">Parts / Tires</span>
    </h4>
  </div>

  <!-- Magic Catalog Lookups -->
  <div *ngIf="isNewTireModalEnabled" class="ui-g-12 p-0  sub-heading-wrapper font-gray">
    <p class="sub-heading mt-15">Magic Catalog Lookups</p>
    <div class="flex-start-center">
      <p>When pricing already exist for an Item, but a Magic Fill is requested, use the following pricing going forward:</p>
    </div>
    <div class="flex-start-center">
      <span class="pr-1 radio-inline">
        <app-radio-button [selectedValue]="isUseOnlinePricing" [value]="false"
          label="Use Store Pricing" [disabled]="isPricingManagementEnable && !isPricingMatricesManagement || isReadOnlyPricing"
          (appChange)="handleChangeCatelog('isUseOnlinePricing', false)"></app-radio-button>
      </span>
      <span class="pr-1 ml-4">
        <app-radio-button  [selectedValue]="isUseOnlinePricing" [value]="true"
          label="Use PartsTech / TireConnnect Pricing"  [disabled]="isPricingManagementEnable && !isPricingMatricesManagement || isReadOnlyPricing"
          (appChange)="handleChangeCatelog('isUseOnlinePricing', true)"></app-radio-button>
      </span>
    </div>
  </div>    

  <div class="ui-g-12" [ngClass]="{'p-0':!isOpenAsDialog}">
    <!-- Start Default Pricing -->
    <div class="ui-g p-0 mt-2 custom-dropdown">
      <div class="ui-g-12 p-0 flex-start-center">
        <div class="ui-g-4 p-0"
          [ngClass]="{'disabled-autocomplete': (isPricingManagementEnable && !isPricingMatricesManagement) }"
          tooltipPosition="top"
          [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement)? 'Please contact admin / store manager to update' : ''">
          <app-dropdown placeholder="Select matrix" theme="border" position="bottom" field="name"
            styleClassSelectedView="parts-pricing-dropdown" [hasError]="errors?.name" [hasCustomItemTemplate]="true" [fontSize]="14"
            [disabled]="(isPricingManagementEnable && !isPricingMatricesManagement) || isReadOnlyPricing" [setPositionDynamically]="false"
            [options]="priceMatrices" [isDropdownIconVisible]="true" [value]="priceMatrix"
            (appSelect)="handleDropdownSelect($event)">
            <ng-template let-item appTemplate="item">
              <div class="flex-column">
                <div class="flex-between-center">
                  <span class="font-14">{{item?.name}}</span>
                  <ng-container *ngIf="!isOpenAsDialog && !isAttributeBasedPricingEnable">
                    <button *ngIf="!item?.default" class="font-12 font-600 font-primary span-btn"
                      [disabled]="(isPricingManagementEnable && !isPricingMatricesManagement)" tooltipPosition="top"
                      [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement) ? 'Please contact admin / store manager to update' : ''"
                      (click)="setDefault(item)">
                      Set Default
                    </button>
                    <span *ngIf="item?.default" class="font-12 font-600 font-primary">
                      Default
                    </span>
                  </ng-container>
                </div>
              </div>
            </ng-template>
          </app-dropdown>
        </div>
        <button class="btn btn-primary ml-2" (click)="createNewPricing()"
          [disabled]="(isPricingManagementEnable && !isPricingMatricesManagement) || isReadOnlyPricing " tooltipPosition="top"
          [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement)  ? 'Please contact admin / store manager to update' : ''">
          Create new
        </button>

        <button class="btn btn-sync ml-2" *ngIf="isUpdatedCatalogPricingEnabled && priceMatrix?.updateInProcess"
          (click)="resyncCatalogPricing()" tooltipPosition="top" [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement)  ? 
          'Please contact admin / store manager to update' : 'Sync all Catalog Items with updated Pricing Matrix'">
          <span>Sync</span>
          <i class="fal fa-sync ml-2"></i>
        </button>
      </div>
    </div>

    <!-- End Default Pricing -->

    <div class="ui-g p-0 mt-15 pricing-name">
      <div class="ui-g-5 p-0 flex-start-center">
        <div class="width-90p">
          <app-input theme="primary" class="title-field" placeholder="Enter title" [value]="priceMatrix?.name"
            [errorMessage]="errors?.name" [disabled]="(isPricingManagementEnable && !isPricingMatricesManagement) || isReadOnlyPricing"
            tooltipPosition="top"
            [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement)  ? 'Please contact admin / store manager to update' : ''"
            [isInvalid]="errors?.name" (appChange)="handleChange('name', $event)">
          </app-input>
        </div>
        <i *ngIf="!priceMatrix.default" class="fas fa-trash font-gray-45 pointer ml-2"
          [ngClass]="{ 'disabled-autocomplete': (isPricingManagementEnable && !isPricingMatricesManagement) || isReadOnlyPricing }"
          [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement)  ? 'Please contact admin / store manager to update' : ''"
          (click)="handleConfirmDeletePricing()"></i>
      </div>
    </div>

    <div class="ui-g p-0 mt-3 mb-2">
      <div class="ui-g-2 p-0">
        <p class="font-16 font-bold m-0">Cost range</p>
      </div>
    </div>

    <!-- Start Price Matrix Table -->
    <div class="ui-g mt-2 p-0">
      <div class="ui-g-12 p-0">
        <div class="part-pricing-table">
          <div class="part-pricing-table-head flex-start-center b-bottom-gray-85">
            <div class="pt-2 pb-2 start font-600">Start</div>
            <div class="p-0 pt-2 pb-2 end font-600">End</div>
            <div class="p-0 pt-2 pb-2 margin font-600">Margin %</div>
            <div class="p-0 pt-2 pb-2 markup font-600">Markup %</div>
            <div class="p-0 pt-2 pb-2 description font-600">Description</div>
            <div class="p-0 pt-2 pb-2 delete"></div>
          </div>

          <div class="part-pricing-table-body">
            <div class="part-pricing-table-row" *ngFor="let pricing of priceMatrix?.items; let pricingIndex = index">
              <app-price-matrix-item [nextUpperLimit]="priceMatrix?.items[pricingIndex + 1]?.max"
                [noOfItems]="priceMatrix?.items?.length" [error]="errors[pricingIndex]" [pricing]="pricing"
                [index]="pricingIndex" [isPricingMatricesManagement]="isPricingMatricesManagement"
                [isPricingManagementEnable]="isPricingManagementEnable"
                [isReadOnlyPricing]="isReadOnlyPricing"
                [isNewItemCategoriesEnable]="isNewItemCategoriesEnable"
                [isAttributeBasedPricingEnable]="isAttributeBasedPricingEnable" (itemBlur)="handleBlur($event)"
                (checkForChanges)="checkForChanges()" (deleteItem)="handleDeleteItem($event)">
              </app-price-matrix-item>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Price Matrix Table -->

    <!-- Start Actions -->
    <!-- *ngIf="!isOpenAsDialog" -->
    <div class="ui-g mt-2 p-0">
      <div class="ui-g-12 p-0 mr-4 ml-2 mt-4">
        <div class="tax-submit flex-end-center pl-2">
          <button class="btn btn-border mr-2 width-80" [disabled]="!isUpdated && !isOpenAsDialog"
            (click)="handleDiscardChange()">
            Cancel
          </button>
          <button class="btn btn-primary width-80" [disabled]="(!isUpdated && !isOpenAsDialog) || isReadOnlyPricing"
            (click)="handleSaveChange()">
            Save
          </button>
        </div>
      </div>
    </div>
    <!-- End Actions -->
  </div>
</div>